module.exports = __webpack_public_path__ + "img/check.14ba1575.svg";